export enum RotationState {
    Ready,
    Rotating,
    RotatingSuccessful,
}
